import React from 'react';
import Markdown from 'react-showdown';
import { DocPage } from '../components/DocPage';
import { readme } from '../utils/Manager';

export function HomePage() {
    return <DocPage><Markdown markdown={readme}/></DocPage>
}

export function Page404() {
    return <DocPage><h1>404 - Not Found</h1></DocPage>
}